class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.closeTimeout = null;
    this.isDesktop = false;
  }

  connectedCallback() {
    this.checkDesktop();
    this.mediaQuery = window.matchMedia('(min-width: 990px)');
    this.mediaQuery.addEventListener('change', this.checkDesktop.bind(this));
    this.setupHoverBehavior();

    this.mainDetailsToggle.querySelector('summary').addEventListener('click', (e) => {
      if (this.isDesktop) {
        e.preventDefault();
        if (this.mainDetailsToggle.hasAttribute('open')) {
          this.close();
        } else {
          this.open();
        }
      }
    });
  }

  checkDesktop() {
    this.isDesktop = window.matchMedia('(min-width: 990px)').matches;
  }

  setupHoverBehavior() {
    this.addEventListener('mouseenter', () => {
      if (!this.isDesktop) return;
      clearTimeout(this.closeTimeout);
      this.closeSiblings();
      this.open();
    });

    this.addEventListener('mouseleave', () => {
      if (!this.isDesktop) return;
      this.closeTimeout = setTimeout(() => {
        this.close();
      }, 180);
    });
  }

  open() {
    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
    }
    this.onToggle();
  }

  closeSiblings() {
    const allMenus = document.querySelectorAll('header-menu');
    allMenus.forEach((menu) => {
      if (menu !== this) {
        clearTimeout(menu.closeTimeout);
        menu.close();
      }
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
